import React from 'react'
import { Empty, Spin } from '@arco-design/web-react'

interface Props {
  title?: string
  state: boolean
  onClick?: () => void
}

const EmptyMod = (props: Props) => {
  const { onClick, state, title } = props

  return (
    <div style={{ cursor: 'pointer' }} onClick={onClick}>
      {state ? (
        <Spin
          dot
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100px',
          }}
        />
      ) : (
        <Empty description={title ? title : '获取失败，点击刷新！'} />
      )}
    </div>
  )
}

export default EmptyMod
